import { render, staticRenderFns } from "./WishlistView.vue?vue&type=template&id=2fbfbb75"
import script from "./WishlistView.vue?vue&type=script&lang=js"
export * from "./WishlistView.vue?vue&type=script&lang=js"
import style0 from "./WishlistView.vue?vue&type=style&index=0&id=2fbfbb75&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports